import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const PATH_TO_COURSES_QUERY = "courses-query";

export const baseActionsPath = `seneca/${PATH_TO_COURSES_QUERY}`;

export const coursesQueryCrudStateConfig: CrudConfig = {
  name: "coursesQuery",
  path: `${baseActionsPath}/meta`,
  callTypes: [AllowedCallTypes.FETCH]
};
